var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.954712 11.7C0.692167 11.7 0.467411 11.6045 0.280447 11.4136C0.0934823 11.2227 0 10.9931 0 10.725V0.975C0 0.706875 0.0934823 0.477344 0.280447 0.286406C0.467411 0.0954687 0.692167 0 0.954712 0H8.95838L11.4565 2.55125V6.74375L10.5018 7.71875V2.99L8.52876 0.975H0.954712V10.725H7.57405L6.61934 11.7H0.954712ZM5.72454 9.66875C6.18317 9.66875 6.57426 9.50481 6.8978 9.17694C7.22134 8.84908 7.38311 8.45096 7.38311 7.98257C7.38311 7.51419 7.22258 7.11479 6.90154 6.78437C6.5805 6.45396 6.19066 6.28875 5.73201 6.28875C5.27338 6.28875 4.88229 6.45269 4.55875 6.78056C4.23521 7.10842 4.07344 7.50654 4.07344 7.97493C4.07344 8.44331 4.23396 8.84271 4.55501 9.17312C4.87605 9.50354 5.26589 9.66875 5.72454 9.66875ZM1.79804 4.16H7.49449V1.83625H1.79804V4.16ZM7.47858 13V12.1875L11.1065 8.4825L11.9021 9.295L8.27417 13H7.47858ZM12.3158 8.8725L11.5202 8.06L12.1408 7.42625C12.2044 7.36125 12.2601 7.32875 12.3078 7.32875C12.3556 7.32875 12.4113 7.36125 12.4749 7.42625L12.9045 7.865C12.9682 7.93 13 7.99771 13 8.06812C13 8.13854 12.9682 8.20625 12.9045 8.27125L12.3158 8.8725Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.a608063b9149aeb15cde77131fbe4d92.svg";
export { ForwardRef as ReactComponent };